export enum DocumentType {
  QRCODE = 0,
  CPF = 1,
  RG = 2,
  CNH = 3,
  SELFIE = 4,
  RG_FRONT = 5,
  RG_BACK = 6,
  MOTHER_NAME = 7,
  BUSINESS_LINE = 8,
  ESTABLISH_FORM = 9,
  FINANCIAL_STATISTIC = 10,
  PHOTO_DOCUMENT = 11,
  CNH_BACK = 12,
  BORN_AT = 13,
  BILLET = 14,
  CNH_FRONT = 15,
  ADDRESS = 16,
  POWER_OF_ATTORNEY = 17,
  CUSTOM = 18,
  ADDRESS_PROOF = 19,
  CNPJ_PROOF = 20,
  SOCIAL_CONTRACT = 21,
  RNE = 22,
  RNE_FRONT = 23,
  RNE_BACK = 24,
  DIGITAL_CNH = 26,
  PROOF_OF_INVOICING = 33,
  COMPANY_STATUTE = 35,
  DECLARATION_OF_BENEFICIARIES = 36,
  ID_WALL_SELFIE_DOCS = 55,
}

export enum DocumentPendingStatus {
  PENDING = 1,
  NO_PENDING = 2,
}

export enum UserGender {
  MALE = 'M',
  FEMALE = 'F',
  OTHER = 'O',
  NOT_SPECIFIED = 'N/S',
}

export enum TermsTypes {
  TERMS_OF_USE = 'TERMS_OF_USE',
  TERMS_OF_USE_CARD = 'TERMS_OF_USE_CARD',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  ACCEPTANCE_OF_TARIFFS = 'ACCEPTANCE_OF_TARIFFS',
  PJ_TARIFF_TABLE = 'PJ-TARIFF-TABLE',
  PF_TARIFF_TABLE = 'PF-TARIFF-TABLE',
  COMMERCIAL_TARIFFS = 'COMMERCIAL_TARIFFS',
}

export enum OnboardingCafStatus {
  ONBOARDING_FINISHED = 'ONBOARDING_FINISHED',
}

export enum CountriesEnum {
  BRL = 76,
}
